module.exports = __webpack_public_path__ + "static/img/legend_xg_spanish_dark.1d48ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_spanish_dark.png
// module id = FOr9
// module chunks = 94